export const focusAreas = {
  strategyPresence: {
    title: "Strategic Social Presence",
    icon: "Hub",
    symptoms: [
      "Inconsistent posting across social platforms",
      "No clear social media strategy or goals",
      "Presence on wrong platforms for your audience",
      "Inactive or abandoned social media accounts"
    ],
    impacts: [
      "Missing opportunities to connect with potential customers",
      "Weak brand presence compared to competitors",
      "Wasted effort on platforms that don't drive results",
      "Inability to build loyal community around your brand"
    ],
    solutions: [
      "Develop comprehensive social media strategy aligned with business goals",
      "Identify optimal platforms for your Saskatchewan target audience",
      "Create consistent brand voice and visual identity across channels",
      "Build content calendar with strategic posting schedule",
      "Optimize profiles with compelling bios, links, and contact info",
      "Conduct competitor analysis to identify opportunities",
      "Set SMART goals and KPIs for each platform"
    ],
    nextSteps: [
      "Audit current social media presence and performance",
      "Research where your target customers spend time online",
      "Define your social media objectives and success metrics",
      "Create 30-day content calendar with consistent themes"
    ],
    insight: "Strategic presence beats random activity every time. 73% of marketers believe their social media efforts have been 'somewhat effective' or 'very effective' for their business - but only when guided by clear strategy. For Saskatchewan businesses, focusing on the right platforms with consistent, purposeful content builds brand awareness and drives real business results."
  },
  contentEngagement: {
    title: "Engaging Content Creation",
    icon: "EmojiEmotions",
    symptoms: [
      "Low engagement rates on posts (likes, comments, shares)",
      "Content that doesn't resonate with audience",
      "One-way communication without community building",
      "Boring, promotional-only content"
    ],
    impacts: [
      "Poor organic reach as algorithms favor engaging content",
      "Failing to build relationships with your audience",
      "Missing opportunities for word-of-mouth marketing",
      "Lower conversion rates from social media traffic"
    ],
    solutions: [
      "Create value-driven content mix: educate, entertain, inspire, promote (80/20 rule)",
      "Use visual content including photos, videos, infographics, and stories",
      "Share behind-the-scenes and local Saskatchewan stories",
      "Encourage user-generated content and community participation",
      "Host interactive content: polls, Q&As, contests, live videos",
      "Respond authentically to comments and messages",
      "Leverage trending topics and hashtags strategically",
      "Showcase customer testimonials and success stories"
    ],
    nextSteps: [
      "Analyze your top-performing posts for patterns",
      "Create content pillars based on audience interests",
      "Develop engagement plan with response protocols",
      "Schedule weekly community interaction time"
    ],
    insight: "Engagement is the currency of social media. Posts with high engagement reach 10x more people organically than those without. Saskatchewan audiences respond to authentic, local content that sparks conversation. Building a community - not just an audience - transforms followers into loyal customers and brand advocates."
  },
  advertisingROI: {
    title: "Social Advertising ROI",
    icon: "TrendingUp",
    symptoms: [
      "No paid social media strategy or budget",
      "Boosting posts randomly without targeting",
      "Poor return on ad spend",
      "Not tracking conversions from social ads"
    ],
    impacts: [
      "Limited reach as organic visibility continues declining",
      "Competitors capturing your target audience through ads",
      "Slow business growth relying only on organic reach",
      "Missing opportunities to scale successful content"
    ],
    solutions: [
      "Develop targeted ad campaigns for specific Saskatchewan audiences",
      "Create compelling ad creative with clear calls-to-action",
      "Use advanced targeting: demographics, interests, behaviors, lookalikes",
      "Implement conversion tracking and pixel setup",
      "A/B test ad variations to optimize performance",
      "Build retargeting campaigns for website visitors and engaged users",
      "Scale winning campaigns and cut underperformers",
      "Align ad objectives with business goals (awareness, leads, sales)"
    ],
    nextSteps: [
      "Set social advertising budget (start with $300-500/month)",
      "Install tracking pixels on your website",
      "Create first targeted campaign with specific goal",
      "Learn platform ad managers (Facebook Ads, LinkedIn Ads)"
    ],
    insight: "Paid social advertising is no longer optional - it's essential. Organic reach on Facebook is now less than 5%, meaning most followers never see your posts. But strategic social ads deliver an average ROI of 250% when done correctly. For Saskatchewan businesses, even modest ad budgets can drive significant results when targeting local audiences with the right message."
  }
};
